import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi, putApi, deleteApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';

import Login from '../../login';
import Register from '../../register';
import BBCode from '../bbcode/bbcode';
import Image from '../upload/image';
import File from '../upload/file';
import FilesGallery from '../upload/files-gallery';
import Gallery from 'react-photo-gallery';
import EmojiPicker from 'emoji-picker-react';
import Giphy from './giphy';
import GifPicker from 'gif-picker-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import moment from 'moment';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import Palette from '../colour/palette';


import "./chatbox.css";
//import { Button } from 'react-bootstrap/lib/InputGroup';

//const fetchGifs = (number) => gf.search(searchTerm, { offset, limit: 10 });


class Chatbox extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      
			chatbox: props.type,
			mchat: props.mchat || false,

			message: '',
			reply: 0,

			chats: {},
			//chatlow: 0,
			chathigh: 0,
			files: [],
			gallery: [],

			users: {},
			userssublist: {},
			guests: 0,
			showusers: false,
			showhelp: false,
			showpage: 0,

			showoptions: 0,

			showextras: false,
			showemojis: false,

			ChatboxListener: null,
			ChatViewers: null,
			WindowFocus: null,

			socketstatus: true,
			SocketConnected: null,

			kickdj: 0,
			ChannelKickDJ: null,

			pingTimer: {},

			//showLogin: 0,

			customMention: false,
			djsconn: {
				start: {
					uid: 0, date: 0, connected: 0
				},
				end: {
					uid: 0, date: 0, connected: 0
				}
			},
			DjsConnListener: null
			
    };

		this.pingtimer = this.pingtimer.bind(this);
		this.handleChatbox = this.handleChatbox.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitClick = this.handleSubmitClick.bind(this);
		//this.handleLogin = this.handleLogin.bind(this);
		//this.handleRegister = this.handleRegister.bind(this);
		this.showUsers = this.showUsers.bind(this);
    this.chatHover = this.chatHover.bind(this);
		this.messageReply = this.messageReply.bind(this);
		this.messageReplyClose = this.messageReplyClose.bind(this);
		this.messageReply2 = this.messageReply2.bind(this);
		this.messageDelete = this.messageDelete.bind(this);
		this.messageRestore = this.messageRestore.bind(this);
		this.messageBan = this.messageBan.bind(this);
		this.showExtras = this.showExtras.bind(this);
		this.showEmojis = this.showEmojis.bind(this);
		this.Emoji = this.Emoji.bind(this);
		this.kickDJ = this.kickDJ.bind(this);
		this.renderImage = this.renderImage.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
  };

	async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
    value.setUser( getUser );
		
		

		//---- Get Chats
		var params = new URLSearchParams();
		const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}`, params);
		//console.log(x.data);
		if( x.status !== 200 ) return;

		let high = 0;
		for await ( let i of Object.keys(x.data.Chatbox) ) {
			if( x.data.Chatbox[i].id > high ) high = x.data.Chatbox[i].id;
		}
		this.setState({chats: x.data.Chatbox, files: x.data.Files, gallery: x.data.Gallery, chathigh: high}, () => {
			this.MoveBottom();
		});

		//---- Connect Chatbox
    EventEmitter.emit(`/chatbox/${this.state.chatbox}/connect`);

		//---- Connected to socket
		const SocketConnected = EventEmitter.addListener('/socket/status', async data => {
			this.setState({socketstatus: data.connected}, ()=>this.ScrollBottom());
		}); this.setState({SocketConnected});

		//---- Incoming data
		const ChatboxListener = EventEmitter.addListener(`/chatbox/${this.state.chatbox}`, async data => {
			//let low = this.state.chatlow+100;
			//console.log(data);
			let high = this.state.chathigh;
			

			let items = {...this.state.chats};
			let start = null;
      //var _play = false;
      
			//---- Finding starting point to delete messages
			for await ( let x of Object.keys(data.Chatbox) ) {
				if( !start ) start = x;
				if( x < start ) start = x;
			}
			//---- Delete messages
			for await ( let x of Object.keys(items) ) {
				if( x < start ) {
					delete items[x];
				}
			}

			this.setState({chats: items},async ()=>{

				//---- Insert Messages
				for await ( let x of Object.keys(data.Chatbox) ) {
					//if( !items[x] ) _play = true;
					items[x] = data.Chatbox[x];
					//---- lowest && highest
					//if( low === 100 || (data.Chatbox[x].id < low && data.Chatbox[x].id < low) ) low = data.Chatbox[x].id;
					if( data.Chatbox[x].id > high ) high = data.Chatbox[x].id;
				}

				let x = document.getElementById('element_within_div');
				const scroll = x.scrollTop + x.offsetHeight >= x.scrollHeight-50 ? true : false;
				//if( _play ) EventEmitter.emit('playNotification' );
				this.setState({chats: items, chathigh: high}, () => { if( scroll ) this.ScrollBottom() });
			});
		}); this.setState({ChatboxListener});

		//---- Viewers
		const ChatViewers = EventEmitter.addListener(`/chatbox/${this.state.chatbox}/viewers`, async data => {
			//console.log(data);
			let groups = {};
			for await ( let x of Object.keys(data.Users) ) {
				let y = data.Users[x].access.level;
				switch(y){
					case 31:
						y = 30;
						break;
					case 21:
						y = 20;
						break;
					case 2:
						y = 1
						break;
				}
				if( !groups[y] ) groups[y] = {};
				groups[y][x] = data.Users[x];
			}
			let guests = data.online - Object.keys(data.Users).length;
			this.setState({users: groups, guests: guests>=0?guests:0});
		}); this.setState({ChatViewers});

		//---- KickDJ
		const ChannelKickDJ = EventEmitter.addListener(`/${this.state.chatbox}/kickdj`, async data => {
			this.setState({kickdj: parseInt(data)},()=>{
				let x = document.getElementById('element_within_div');
				const scroll = x.scrollTop + x.offsetHeight >= x.scrollHeight-50 ? true : false;
				if( scroll ) this.ScrollBottom();
			});
		}); this.setState({ChannelKickDJ});
		
		//---- DJ Connections
		
		const DjsConnListener = EventEmitter.addListener('/clubbers/djsconnection', async data => {
			if( this.state.chatbox === 'clubbers' ) {
				this.setState({djsconn: data});
			}
		}); this.setState({DjsConnListener});

		//---- Window gets focus
		const WindowFocus = window.addEventListener("focus", () => { 
			this.MoveBottom();
			this.pingtimer();
		}); this.setState({WindowFocus});

		//---- Send Pings
		this.setState({pingTimer: setInterval(this.pingtimer, 60000)});
    return ()=>{
      clearInterval(this.state.pingTimer);
    }
		
		
	}

	componentWillUnmount() {
		EventEmitter.emit(`/chatbox/${this.state.chatbox}/disconnect` );
		if( this.state.ChatboxListener ) this.state.ChatboxListener.remove();
		if( this.state.ChatViewers ) this.state.ChatViewers.remove();
		if( this.state.WindowFocus ) this.state.WindowFocus.remove();
		if( this.state.SocketConnected ) this.state.SocketConnected.remove();
		if( this.state.ChannelKickDJ ) this.state.ChannelKickDJ.remove();
		clearInterval(this.state.pingTimer); 
	}


	//---- Ping Timer every minute
	async pingtimer() {
		EventEmitter.emit(`/chatbox/${this.state.chatbox}/ping`, {high: this.state.chathigh});
	}


	//---- Scrolling
	MoveBottom() {
      let x = document.getElementById('element_within_div');
      if( x ) x.scrollTo({top: 5000, behavior: 'instant'});
	}
	ScrollBottom() {
		let x = document.getElementById('element_within_div');
    if( x ) x.scrollTo({top: x.scrollHeight, behavior: 'smooth'});

	}

	//---- Chatter box
	handleChatbox(e) {
		
		this.setState({message: e.target.value.substring(0,400)});
	}
	async handleSubmit(event, click = false) {
    if(( event.keyCode === 13 && !event.shiftKey ) || click ) {
			if( this.state.message === '' ) return;

			if( this.state.message === '!help' ) {
				this.setState({message: '', showpage: this.state.showpage===2?0:2},()=>{
					this.MoveBottom();
				});
			} else {
				const params = new URLSearchParams();
				params.append('reply', this.state.reply);
				params.append('message', this.state.message);
				let reply = this.state.reply;
				let message = this.state.message;
				this.setState({reply: 0, message: ''},async ()=>{
					const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
					if( x.status === 200 || x.status === 210 ) {
						
					} else {
						this.setState({reply, message});
					}
				});
			}
    }
  }
	async handleSubmitClick() {
		if( this.state.message === '' ) return;

		if( this.state.message === '!help' ) {
			this.setState({message: '', showpage: this.state.showpage===2?0:2},()=>{
				this.MoveBottom();
			});
		} else {
			const params = new URLSearchParams();
			params.append('reply', this.state.reply);
			params.append('message', this.state.message);
			const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
			if( x.status === 200 ) {
				this.setState({reply: 0, message: ''});
			}
		}
  }

	/*handleLogin() {
		if(window.location.pathname==='/mchat') 
			if( this.state.showLogin === 1 )
				this.setState({showLogin: 0},()=>{this.ScrollBottom()});
			else
				this.setState({showLogin: 1});
		else
			window.location.href = '/login';
	}

	handleRegister() {
		if(window.location.pathname==='/mchat') 
			if( this.state.showLogin === 2 )
				this.setState({showLogin: 0},()=>{this.ScrollBottom()});
			else
				this.setState({showLogin: 2});
		else
			window.location.href = '/register';
	}*/


	//---- Showing users
	showUsers() {
		this.setState({showusers: !this.state.showusers}, () => { if( !this.state.showusers ) this.MoveBottom(); });
	}

	showHelp() {
		this.setState({showhelp: !this.state.showhelp}, () => { if( !this.state.showhelp ) this.MoveBottom(); });
	}

	showPage(id) {
		/*
			0 - main chats
			1 - users online
			2 - help page
			10 - Show Login
			11 - Show Register
		*/
		this.setState({showpage: this.state.showpage===id?0:id},()=>{
			if( this.state.showpage === 0 ) this.MoveBottom();
		});
	}

	//---- Dropdown Buttons
  chatHover( id ) {
    this.setState({ showoptions: id });
  }

	async messageReply() {
		let message = '';
		if(this.state.chats[this.state.showoptions].uid === 112) {
			//message = this.state.message + "@" + this.state.chats[this.state.showoptions].name.replace('(Twitch) ','') + " ";
		} else {
			//message = this.state.message + "@" + this.state.chats[this.state.showoptions].username + " ";
		}

		//var 
		this.setState({message, reply: this.state.showoptions},()=>{
			this.ScrollBottom();
			document.getElementById("textarea").focus();
		});
	}
	async messageReplyClose() {
		this.setState({reply: 0, message: ''});
	}
	async messageReply2(group, id) {
		if( this.state.customMention !== false ) {
			const _name = new RegExp('.{' + this.state.customMention + '}([a-zA-Z0–9_]*)');
			const names = this.state.message.match(_name);
			let content = this.state.message.substring(0, this.state.customMention) + this.state.users[group][id].user.username + this.state.message.substring(this.state.customMention+names[1].length);
			this.setState({message: content, customMention: false});
		} else {
			let message = this.state.message + "@" + this.state.users[group][id].user.username + " ";
			this.setState({message});
		}
	}

	async userMention(group, id) {
		try {
			const _name = new RegExp('.{' + this.state.customMention + '}([a-zA-Z0–9_]*)');
			const names = this.state.message.match(_name);
			let content = this.state.message.substring(0, this.state.customMention) + this.state.userssublist[group].username + this.state.message.substring(this.state.customMention+names[1].length) ;
			this.setState({message: content, customMention: false});
		} catch(error) {}
	}

	async messageDelete() {
		if( window.confirm("Are you sure you wish to delete this message?")) {
			var params = new URLSearchParams();
			params.append('id', this.state.showoptions);
			await deleteApi(`/api/v2/chatbox/${this.state.chatbox}/delete`,params);
		}
	}

	async messageRestore() {
		if( window.confirm("Are you sure you wish to resore this message?") ) {
			var params = new URLSearchParams();
			params.append('id', this.state.showoptions);
			await postApi(`/api/v2/chatbox/${this.state.chatbox}/restore`,params);
		}
	}

	async messageBan() {
		if( window.confirm("Are you sure you wish to delete this message and ban the guest?") ) {
			var params = new URLSearchParams();
			params.append('id', this.state.showoptions);
			await deleteApi(`/api/v2/chatbox/${this.state.chatbox}/ban`,params);
		}
	}


	timeAgo(time) {
		const _time = Math.floor( ((Date.now()/1000) - time) / 60) ;
		var _return = '';
		if( _time >= 10 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <small>&nbsp;&nbsp;{_return}</small> );
	}

	findName(name) {
		try{
			const user = this.context;
			let m = name.search("@"+user.user.user.username);
			let n = name.search("@oldie");
			let o = name.search("@pops");
			let p = name.search("@baldi");
			if( p >= 0 && user.user.user.id === 100 ) return true;
			if( o >= 0 && user.user.user.id === 86 ) return true;
			if( n >= 0 && user.user.user.id === 61 ) return true;
			if( m >= 0 ) return true; else return false;
		} catch(error) {return false;}
	}

	findUser(reply) {
		if( reply === 0 ) return;
		try{
			const user = this.context;
			if( this.state.chats[reply].uid === user.user.user.id ) return true;
		} catch(error) {return false;}
	}

	showExtras() {
		this.setState({showextras: !this.state.showextras, customMention: false, showemojis: false});
	}

	showEmojis() {
		this.setState({showemojis: !this.state.showemojis, showextras: false, customMention: false});
	}

	Emoji(event1, event2) {
		this.setState({message: this.state.message + event1.emoji});
	}

	Giphy = async (url) => {
		document.body.click();
		const params = new URLSearchParams();
    params.append('message', '[img]https://media.giphy.com/media/'+url+'/giphy.gif[/img]');
    await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
		this.setState({showextras: false, customMention: false});
	}

	async Tenor(url) {
		document.body.click();
		const params = new URLSearchParams();
    params.append('message', url);
    await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
		this.setState({showextras: false, customMention: false});
	}

	async Image(event) {
		document.body.click();
		const params = new URLSearchParams();
    params.append('message', event.target.currentSrc);
    await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
		this.setState({showextras: false, customMention: false});
	}

	async File(event) {
		document.body.click();
		const params = new URLSearchParams();
    params.append('message', `[file]${event}[/file]`);
    await postApi(`/api/v2/chatbox/${this.state.chatbox}/post`, params);
		this.setState({showextras: false, customMention: false});
	}

	rankColor(rank) {
		//console.log(rank);
		switch( rank ) {
			case "Owner": return '#DC143C';
			case "Admin": case 'Junior Admin': return '#FF4500';
			case "Clubbers DJ": case 'Radio DJ': {
				switch(this.state.chatbox) {
					case 'clubbers': return '#07E6A5';
					case 'radio': return 'rgb(3, 170, 243)';
					default: return '#273be2';
				}
			}
			case 'Pending': return '#ffffff';
			default: return '#228B22';
		}
		//if( rank === "Owner" ) return '#FFD700';
		//return '#ffff00';
	}

	popOut() {
		document.body.click();
		window.open('/mchat', 'Resource', 'toolbar=no ,location=0, status=no, titlebar=no, menubar=no,width=400,height=800');
	}

	async customMention(e) {
		try {
			setTimeout(async ()=>{
				const _name = new RegExp('.{' + this.state.customMention + '}([a-zA-Z0–9_]*)');
				const names = this.state.message.match(_name);
				if( names[1].length > 1 ) {
					let params = new URLSearchParams();
					params.append('username', names[1]);
					const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}/mention`, params);
					this.setState({userssublist: x.data});
				}
			},500);
		} catch(error) {}
	}

	renderImage(index, left, top, key, photo) {
		return(
			<div className="" key={index.index} style={{margin: index.margin, cursor: 'pointer', position: 'relative', float: 'left'}}>
				<img src={index.photo.src} width={index.photo.width} height={index.photo.height} style={{}} onClick={event=>this.Image(event)} alt="Profile" />
				<Button size="sm" onClick={()=>this.deleteImage(index.photo.src)} style={{position: 'absolute', left: 2, bottom: 2, backgroundColor: 'rgb(33,37,41) !important', padding: '2px 4px'}}>
					<FontAwesomeIcon icon="trash" />
				</Button>
			</div>
		)
	}

	async deleteImage(src) {
		if( window.confirm("Are you sure you wish to delete this image?" ) ) {
			var params = new URLSearchParams();
			params.append('image', src);
			await deleteApi(`/api/v2/chatbox/${this.state.chatbox}/image`,params);
			
			const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}`, params);
			this.setState({gallery: x.data.Gallery});

		}
	}

	async kickDJ() {
		let params = new URLSearchParams();
		params.append('channel', this.state.chatbox);
		params.append('kickdj', this.state.kickdj);
		await putApi(`/api/v2/livechat/kickdj`, params);
	}

	render() {
		const user = this.context;
		const kicked = user.user.access.kicked > Math.floor(Date.now()/1000) ? true : false;
		const chats = 
      Object.keys(this.state.chats).map((e,i) => {
        return (
          <div key={e}>
            {(this.state.chats[e].flags!==1||user.user?.admin?.admin_access) &&
              <div className="col-12 py-0 chatbox-message">
                <div className="row pb-2" style={{backgroundColor: (this.findName(this.state.chats[e].text) || this.findUser(this.state.chats[e].reply))?'#1c246f':'transparent'}} onMouseEnter={(f) => this.chatHover(e)} onMouseLeave={(f) => this.chatHover(0)}>
                  <div className="text-center pt-2 px-2 mx-0 chatbox-avatar">
										<img src={`https://mix365.co.uk${this.state.chats[e].avatar}`} alt="A" style={{width: 30, height: 30, borderRadius: '50%'}} />
										{//user.user.user.rank>=5&&
											<div className="chatbox-level" style={{backgroundColor: this.rankColor(this.state.chats[e].level)}}></div>
										}
                  </div>
                  <div className="col ps-0 pe-5 pt-0 mx-0 chatbox-element">
										<Link to={`/${this.state.chats[e].username.replaceAll(' ','_')}`} className={`chatbox-channel-${this.state.chatbox}`}>{this.state.chats[e].djtitle?this.state.chats[e].djtitle:this.state.chats[e].username}</Link>
										{this.timeAgo(this.state.chats[e].time)}<br />
										{this.state.chats[e].reply > 0 &&
											<React.Fragment>
												
												<FontAwesomeIcon icon="reply" size="xs" /> {this.state.chats[e]._reply.djtitle?this.state.chats[e]._reply.djtitle:this.state.chats[e]._reply.username}<br />
												<div className="chatbox-message-reply-message">
													<BBCode text={this.state.chats[e]._reply.text.length>75?this.state.chats[e]._reply.text.substring(0,100)+'...':this.state.chats[e]._reply.text} /><br />
												</div>
											</React.Fragment>
										}
										{this.state.chats[e].flags===1?
											<div className="mssage-delete">Message Deleted<br />
												<BBCode text={this.state.chats[e].text} />
											</div>
										:
											<BBCode text={this.state.chats[e].text} />
										}
										{this.state.showoptions === e && user.user.user.rank >= 2 &&
											<div className="chatbox-dropdown">
												{this.state.chats[e].uid!==112 &&
													<><FontAwesomeIcon icon="reply" onClick={this.messageReply} />&nbsp;</>
												}
												<span className="dropdown">
													&nbsp;<FontAwesomeIcon icon="ellipsis" />
													<div className="dropdown-content">
														{this.state.chats[e].uid===112 ?
															<>
																{(this.state.chats[e].name !== '(Twitch) StreamElements' && this.state.chats[e].name !== '(Twitch) TwitchMusicID') &&
																	<div onClick={this.messageReply}>Reply to {this.state.chats[e].name.replace('(Twitch) ','')}</div>
																}
															</>
														:
															<div onClick={this.messageReply}>Reply to {this.state.chats[e].username}</div>
														}
														
														{user.user?.admin?.mod_access &&
															<>
																{this.state.chats[e].flags===1 ?
																	<div onClick={this.messageRestore}>Restore Message</div>
																:
																	<div onClick={this.messageDelete}>Delete Message</div>
																}
															</>
														}
														{user.user?.admin?.mod_access && this.state.chats[e].rid &&
															<div onClick={this.messageBan}>Delete & Ban Guest {this.state.chats[e].banned > 0 && <FontAwesomeIcon icon="check" />}</div>
														}
														<div>{this.state.chats[e].level}</div>
													</div>
												</span>
											</div>
										}
                  </div>
                </div>
              </div>
            }
          </div>
        )
      })
		const users = 
      Object.keys(this.state.users).reverse().map((e,i) => {
        return (
          <div key={i}>
						{e==='32'&&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersOwner">
									Owner
								</div>
							</div>
						}
						{e==='30' &&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersAdmin">
									Admin
								</div>
							</div>
						}
						{e==='20' &&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersDJ">
									DJ's
								</div>
							</div>
						}
						{/*e==='10'&&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersSubscriber">
									Subscribers
								</div>
							</div>
						*/}
						{e==='10'&&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersMember">
									Members
								</div>
							</div>
						}
						{e==='1'&&
							<div className="col-6 chatbox-user chatbox-online-user">
								<div className="chatUsersPending">
									Pending
								</div>
							</div>
						}
						{Object.keys(this.state.users[e]).map((f,j) => {
							return (
								<React.Fragment key={j}>
									{//this.state.users[e][f].user.id !== 3 &&
										<>
											{this.state.users[e][f].connected === 1 &&
												<div className="col-12 pb-0 chatbox-user">
													<div className="row" /*onMouseEnter={(f) => this.chatHover(e)} onMouseLeave={(f) => this.chatHover(0)}*/>
														<div className="text-center pt-2 ps-2 pe-0 ms-2 me-0 chatbox-online-avatar">
															<img src={`https://mix365.co.uk${this.state.users[e][f].user.avatar}`} alt="A" />
															<div className="chatbox-level" style={{backgroundColor: this.rankColor(this.state.users[e][f].user.rankname)}}></div>
														</div>
														<div className="col ps-0 ms-0 pr-0 chatbox-element-member">
															<Link to={`/${this.state.users[e][f].user.username.toLowerCase().replaceAll(' ','_')}`}>
																{this.state.users[e][f].user.title?<>{this.state.users[e][f].user.title} ({this.state.users[e][f].user.username})</>:this.state.users[e][f].user.username}
															</Link>
														</div>
													</div>
												</div>
											}
										</>
									}
								</React.Fragment>
							)
						})}
          </div>
        )
      })
		const online = 
      Object.keys(this.state.users).reverse().map((e,i) => {
        return (
          <React.Fragment key={i}>
						{Object.keys(this.state.users[e]).map((f,j) => {
							return (
								<React.Fragment key={j}>
									{this.state.users[e][f].connected === 1 &&
										<div style={{padding: 0}}>
											<div className="row py-2 px-1 m-0 user-online" onClick={() => this.messageReply2(e, this.state.users[e][f].user.id)}>
												<div className="p-0 text-center " style={{width:32}}>
														<img src={`https://mix365.co.uk${this.state.users[e][f].user.avatar}`} alt="A" style={{width: 24, height: 24, borderRadius: '50%'}} />
												</div>
												<div className="col p-0 chatbox-element" style={{position: 'relative'}}>
													<span>
														{this.state.users[e][f].user.title?<>{this.state.users[e][f].user.title} ({this.state.users[e][f].user.username})</>:this.state.users[e][f].user.username}
													</span>
												</div>
											</div>
										</div>
									}
								</React.Fragment>
							)
						})}
          </React.Fragment>
        )
      })
		const onlinesub = 
      Object.keys(this.state.userssublist).reverse().map((e,i) => {
        return (
					<div key={i} style={{padding: 0}}>
						<div className="row py-2 px-1 m-0 user-online" onClick={() => this.userMention(e, this.state.userssublist[e].id)}>
							<div className="p-0 text-center " style={{width:40}}>
								<img src={`https://mix365.co.uk${this.state.userssublist[e].avatar}`} alt="A" style={{width: 24, height: 24, borderRadius: '50%'}} />
							</div>
							<div className="col p-0 chatbox-element" style={{position: 'relative'}}>
								<span>
									{this.state.userssublist[e].title?<>{this.state.userssublist[e].title} ({this.state.userssublist[e].username})</>:this.state.userssublist[e].username}
								</span>
							</div>
						</div>
					</div>
        )
      })
		return (
			<div className="chatbox">
				<div className="chatbox-inner">
				{/*</div><div className="row px-2" style={{position: 'relative', display: 'block', height: '100%', maxHeight: '100%'}}>*/}
					<div className="col-12 ms-0 py-1 chatlive-title">
						<div className="row">
							<div className="col pb-1">
								Mix365 {this.state.chatbox.charAt(0).toUpperCase()}{this.state.chatbox.slice(1)} Chat
							</div>
							{user.user.user?.rank >=2 &&
								<div className="col-4">
									<div className="text-right">

									{this.state.mchat&&<><Link to={'/mchat'}><FontAwesomeIcon icon="backward" /></Link>&nbsp;&nbsp;</>}
									<FontAwesomeIcon icon="circle-info" onClick={()=>this.showPage(2)} className="pointer" />&nbsp;&nbsp;

										{/*<OverlayTrigger trigger="click" placement="bottom" rootClose="true" overlay={
											<Popover id="popover-basic">
												<Palette colour={this.props.colour} newColour={this.props.newColour} />
											</Popover>
											}>
											<i className="fa fa-droplet" style={{cursor: 'pointer'}}></i>
										</OverlayTrigger>&nbsp;&nbsp;*/}

										<OverlayTrigger trigger="click" placement="bottom" rootClose="true" overlay={
											<Popover id="popover-basic" className="bg-dark">
												<ul id="2" className="chatbox-menu">
													<li id="menu-item" className="menu-item menu-item-type-custom chat-mobile"><a href={window.location.pathname.indexOf('/mchat')===0?'/':'/mchat'}><span className="pagelayer-nav-menu-title">{window.location.pathname.indexOf('/mchat')===0?'Return to Website':'Mobile Chat'}</span></a></li>
													<li id="menu-item" className="menu-item menu-item-type-custom chat-web"><Link to={`#`} onClick={()=>{this.popOut(); document.body.click();}}><span className="pagelayer-nav-menu-title">Pop out chat</span></Link></li>
													<li id="menu-item" className="menu-item menu-item-type-custom chat-web"><Link to={'#'} onClick={()=>{this.props.theatre(); document.body.click();}}><span className="pagelayer-nav-menu-title">Theatre Mode</span></Link></li>
												</ul>
											</Popover>
											}>
											<FontAwesomeIcon icon="gear" className="pointer" />
										</OverlayTrigger>&nbsp;&nbsp;


										<FontAwesomeIcon icon="user" onClick={()=>this.showPage(1)} className="pointer" />

									</div>
								</div>
							}
						</div>
					</div>
					
					{this.state.djsconn?.start?.uid === user.user?.user?.id &&
						<div className="chatbox-header text-vcenter">
							{Math.floor(Date.now()/1000) > this.state.djsconn.start.date+60 ?
								<>
									{this.state.djsconn.start.connected ?
										<>Stay Connected</>
									:
										<>Start Streaming</>
									}
								</>
							:
								<>Start Streamaing at {moment((this.state.djsconn.start.date+60)*1000).format("HH:mm")}</>
							}
						</div>
					}
					{this.state.djsconn?.end?.uid === user.user?.user?.id && this.state.djsconn?.end?.connected === 1 &&
						<div className="chatbox-header text-vcenter">
							{Math.floor(Date.now()/1000) > this.state.djsconn.end.date ?
								<>
									{this.state.djsconn.end.connected === 1 &&
										<>Disconnect</>
									}
								</>
							:
								<>Stream Ending at {moment((this.state.djsconn.end.date)*1000).format("HH:mm")}</>
							}
						</div>
					}
					
					<div id="element_within_div" className={`chatbox-inner-context col-12 p-0 m-0 ${this.state.chatbox==='/admin/chatbox'?'chatlive-adminchats':'chatlive-chats'}`} style={{position: 'relative', overflowX: 'hidden', overflowY: 'scroll'}}>
						{this.state.showpage === 0 &&
							<>
								{chats}
								{!this.state.socketstatus &&
									<div className="col-12 chatbox-message-socketstatus text-center">
										Lost connection to server, reconnecting ...
									</div>
								}
								{this.state.reply!==0 &&
									<div className="col-12 chatbox-message-reply">
										
										<strong>Replying to: <span className="chatbox-message-reply-dj">{this.state.chats[this.state.reply].djtitle?this.state.chats[this.state.reply].djtitle:this.state.chats[this.state.reply].username}</span></strong>
										<span style={{float:'right'}} onClick={this.messageReplyClose}>Close</span>
										<br />
										<BBCode text={this.state.chats[this.state.reply].text} />
											
									</div>
								}
								{(this.state.kickdj !== 0 && ( this.state.kickdj === user.user.user.id || user.user.admin.admin_access ) ) &&
									<div className="col-12 chatbox-message-reply">
										<strong>Current DJ running over?</strong>&nbsp;&nbsp;&nbsp;
										<Button size="sm" onClick={this.kickDJ}>Kick DJ</Button>
									</div>
								}
							</>
						}
						{this.state.showpage === 1 &&
							<>
								{users}
								{this.state.guests > 0&&
									<div>
										<div className="col-6 chatbox-user" style={{fontSize: 14, paddingTop: 6, paddingLeft: 20, paddingBottom: 0, color: 'rgb(55, 186, 251)'}}>
											<div className="chatUsersMember">
												Guests
											</div>
										</div>
										<div className="col-12 pb-0 chatbox-user">
											<div className="row" /*onMouseEnter={(f) => this.chatHover(e)} onMouseLeave={(f) => this.chatHover(0)}*/>
												<div className="text-center pt-2 ps-2 pe-0 ms-2 me-0" style={{width:48, position: 'relative'}}>
													<img src="https://mix365.co.uk/images/user_small.png" alt="A" style={{width: 24, height: 24, borderRadius: '50%'}} />
													<div className="" style={{position:'absolute', right: 8, top:24 , backgroundColor: this.rankColor("Members"),height: 10,width: 10,borderRadius: 4}}></div>
												</div>
												<div className="col ps-0 ms-0 pr-0 chatbox-element" style={{paddingTop: '13px', position: 'relative'}}>
													<Link to={``} style={{color: 'rgb(55, 186, 251)'}}>{this.state.guests} guest{this.state.guests>1&&'s'}</Link>
												</div>
											</div>
										</div>
									</div>
								}
							</>
						}
						{this.state.showpage === 2 &&
							<div className="chatbox-help">
								<h3>Help Commands</h3>
								{/*<b>!play</b> - Show audio player / Mobile chat only<br />*/}
								<b>!list</b> - View upcoming list of DJ's<br />
								<b>!next</b> - View next DJ<br />
								<b>!song</b> - View current playing track<br />
								<b>!socials</b> - View DJ's Socials<br />
								<b>!listen</b> - View current listeners<br />
								<b>!video</b> - Displays Video Information<br />
								<b>!levels</b> - Show Audio mean and max levels<br /><br />
								{/*<b>!audio</b> - Advise DJ you hear Audio issues<br /><br />*/}

								{user.user.admin?.mod_access &&
									<>
										<h3>DJ's</h3>
										<b>!screenshot</b> - Capture screenshot of the video<br />
										<b>!kick @username</b> - Disables member from chatting for 24 hours<br />
									</>
								}

							</div>
						}
						{this.state.showpage === 10 &&
							<Login />
						}
						{this.state.showpage === 11 &&
							<Register />
						}
									
						{this.state.showusers ?
							<>
							</>
						:
							<>
							{this.state.showLogin === 0 &&
								<></>
							}
							{this.state.showLogin === 1 &&
								<></>
							}
							{this.state.showLogin === 2 &&
								<></>
							}
							</>
						}
					</div>
					{user.user.access?.verified ?
						<>
							<Row className="px-0 mx-0 py-1 chatlive-footer">
								<div className={`chatlive-button ${this.state.showextras&&'chatlive-extra'}`}>
									{!this.state.showextras?
										<>
											{kicked?
												<FontAwesomeIcon className="" icon="circle-plus" />
											:
												<FontAwesomeIcon className="" icon="circle-plus" onClick={this.showExtras} />
											}
										</>
									:
										<>
											<OverlayTrigger placement="bottom" trigger="hover" key="overlay-1" overlay={<Tooltip id="tooltip1">Insert Giphy</Tooltip>}>
												<label>
													<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
														<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
															<div className="dropdown-content-giphy">
																<Giphy selectUrl={this.Giphy} />
															</div>
														</Popover>
														}>
														<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="image" /></span>
													</OverlayTrigger>
												</label>
											</OverlayTrigger>
											<OverlayTrigger placement="bottom" trigger="hover" key="overlay-2" overlay={<Tooltip id="tooltip1">Insert Tenor</Tooltip>}>
												<label>
													<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
														<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
															{/*<div className="dropdown-content-giphy" style={{paddingRight: 20}}>*/}
																{/*<Tenor key="AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg" initialSearch="welcome" contentfilter="high" ar_range="all" limit="16" onSelect={result => this.Tenor(result.url)} />*/}
																<GifPicker tenorApiKey={"AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg"} onGifClick={result => this.Tenor(result.url)} width='100%' theme="dark" autoFocusSearch={false} />
															{/*</div>*/}
														</Popover>
														}>
														<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="images" /></span>
													</OverlayTrigger>
												</label>
											</OverlayTrigger>
											<OverlayTrigger placement="bottom" trigger="hover" key="overlay-3" overlay={<Tooltip id="tooltip1">Mention member</Tooltip>}>
												<label>
													<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
														<Popover id="popover-basic" popover-positioned="top" className="popover-mention bg-dark">
															<div className="dropdown-content-mention">
																{online}
															</div>
														</Popover>
														}>
														<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="user" /></span>
													</OverlayTrigger>
												</label>
											</OverlayTrigger>
											<OverlayTrigger placement="bottom" trigger="hover" key="overlay-4" overlay={<Tooltip id="tooltip1">{this.state.chatbox==='technical'?'Upload File':'Upload Image'}</Tooltip>}>
												<label>
													<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
														<Popover id="popover-basic" popover-positioned="top" className="popover-image bg-dark">
															<div className="dropdown-content-image bg-dark">
																<div className="dropdown-content-inner">
																	<div className="dropdown-content-header">
																		{this.state.chatbox==='technical'?
																			<>
																				<File channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
																				<FilesGallery files={this.state.files} submit={event=>this.File(event)} />
																			</>
																		:
																			<Image channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
																		}
																	</div>
																	<div className="dropdown-content-body">
																		{Object.keys(this.state.gallery).length === 0 ?
																			<Gallery photos={this.state.gallery} renderImage={this.renderImage} />
																		:
																			<Gallery photos={this.state.gallery} direction={"column"} columns={4} renderImage={this.renderImage} />
																		}
																	</div>
																</div>
															</div>
														</Popover>
														}>
														<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="cloud-arrow-up" /></span>
													</OverlayTrigger>
												</label>
											</OverlayTrigger>
										</>
									}
								</div>
								<div className="col px-0 mx-0 text-vcenter">
									{/*this.state.reply!==0&&
										<div style={{position: 'absolute', left: 0, right: 25, bottom: 50, backgroundColor: '#ffffff'}}>
											Replying to: {this.state.chats[this.state.reply].djtitle?this.state.chats[this.state.reply].djtitle:this.state.chats[this.state.reply].username}
											<span style={{float:'right'}} onClick={this.messageReplyClose}>Close</span>
											<br />
											<BBCode text={this.state.chats[this.state.reply].text} />
										</div>
									*/}
									{this.state.customMention!==false &&
										<Popover id="popover-basic" show={this.state.customMention} popover-positioned="top" className="popover-mention bg-dark" style={{bottom: 50, top:'unset'}}>
											<div className="dropdown-content-mention">
												{Object.keys(this.state.userssublist).length === 0 ?online:onlinesub}
											</div>
										</Popover>
									}
									<textarea rows="1" id="textarea" className="chatlive-message" value={this.state.message} onChange={this.handleChatbox} onClick={()=>this.setState({showemojis:false, showextras: false, customMention: false})}
										disabled={kicked}
										placeholder={kicked?'Chat disabled':'Send a message'}
										onKeyDown={(e)=>{
											if( e.shiftKey && e.code==="Quote" ) {
												this.setState({customMention: e.target.selectionStart+1});
											}
											if( e.keyCode === 13 && !e.shiftKey ) {
												e.preventDefault();
												e.stopPropagation();
											}
											this.handleSubmit(e);
											if( this.state.customMention !== false ) {
												this.customMention(e);
												if( e.keyCode === 32 ) this.setState({customMention: false});
											}
										}}
										onKeyUp={(e)=>{
											if( ( e.which || e.keycode ) === 229 ) {
												let ss = e.target.selectionStart-1 || 0;
												if( e.target.textContent.substr(ss,1) === '@' ) {
														this.setState({customMention: e.target.selectionStart},()=>{
														this.customMention(e);
													});
												}
												if( e.target.textContent.substr(ss,1) === ' ' ) {
													this.setState({customMention: false});
												}
											}
										}} style={{paddingRight:30}}
									></textarea>
									<span className="chatlive-message-emoji" style={{cursor: 'pointer'}}>
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-emoji bg-dark">
												<div className="">
													<EmojiPicker onEmojiClick={this.Emoji} autoFocusSearch={false} disableDiversityPicker theme={"dark"} />
												</div>
											</Popover>
											}>
											<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><img src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png" alt="Emoji Picker" /></span>
										</OverlayTrigger>
									</span>
									{/*<span className="chatlive-message-emoji" style={{cursor: 'pointer'}} onClick={this.showEmojis}><img src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png" alt="Emoji Picker" /></span>*/}
									{/*this.state.showemojis && !kicked &&
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-mention bg-dark">
												<div className="dropdown-content-mention">
													<EmojiPicker onEmojiClick={this.Emoji} disableDiversityPicker theme={"dark"} />		
												</div>
											</Popover>
											}>
											<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="user" /></span>
										</OverlayTrigger>

										
									*/}

									{/* <div className="" style={{position: 'absolute', bottom: 50, overflow: 'visible', zIndex: '10000'}}>

											<EmojiPicker onEmojiClick={this.Emoji} disableDiversityPicker theme={"dark"} />
										</div> */}
								</div>
								<div className="chatlive-button" onClick={(e)=>this.handleSubmit(e, true)}>
									<FontAwesomeIcon className="" icon="circle-right" />
								</div>
							</Row>
							{/*<div className="col-12 mx-1 chatlive-message ps-0 pe-2 pt-2">
								{this.state.reply!==0&&
									<div style={{position: 'absolute', left: 0, right: 25, bottom: 50, backgroundColor: '#ffffff'}}>
										Replying to: {this.state.chats[this.state.reply].djtitle?this.state.chats[this.state.reply].djtitle:this.state.chats[this.state.reply].username}
										<span style={{float:'right'}} onClick={this.messageReplyClose}>Close</span>
										<br />
										<BBCode text={this.state.chats[this.state.reply].text} />

									</div>
								}
								<textarea rows="2" placeholder="Send a message" value={this.state.message} onChange={this.handleChatbox} onClick={()=>this.setState({showemojis:false})} onKeyDown={(e)=>{
									if (e.keyCode === 13 && !e.shiftKey) {
										e.preventDefault();
										e.stopPropagation();
									}
									this.handleSubmit(e);
								}} style={{paddingRight:30}}></textarea>
								<span className="chatlive-message-emoji" style={{cursor: 'pointer'}} onClick={this.showEmojis}>😁</span>
								{this.state.showemojis &&
										<div className="" style={{position: 'absolute', bottom: 50, overflow: 'visible', zIndex: '10000'}}>
											<EmojiPicker  onEmojiClick={this.Emoji} disableDiversityPicker />
										</div>
								}
								
							</div>
							<div className="col-12 mx-1 chatlive-send">
								<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
									<div className="text-right">

										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top">
												<div className="dropdown-content-giphy" style={{display: 'block', bottom: 0, height: 500, padding: 6}}>
													
													<Giphy selectUrl={this.Giphy} />
													
												</div>
											</Popover>
											}>
											<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 5px'}}>G</span>
										</OverlayTrigger>&nbsp;&nbsp;
										

										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top">
												<div className="dropdown-content-tenor" style={{display: 'block', bottom: 0, height: 500, padding: 6}}>
													
													<Tenor key="AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg" initialSearch="welcome" contentfilter="high" ar_range="all" limit="16" onSelect={result => this.Tenor(result.url)} />
													
												</div>
											</Popover>
											}>
											<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 5px'}}>T</span>
										</OverlayTrigger>&nbsp;&nbsp;
											
										

										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top">
												<div className="dropdown-content" style={{display: 'block', bottom: 0, width: 350}}>
													{online}
												</div>
											</Popover>
											}>
											<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 5px'}}>@</span>
										</OverlayTrigger>&nbsp;&nbsp;
										<button onClick={this.handleSubmitClick} className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 10px'}}>
											<span className="">Chat</span>
										</button>
										
									</div>
								</div>
										</div>*/}
						</>
					:
						<Row className="gx-0 chatlive-footer">
							{user.user?.access?.level === 2 ?
								<>
									<Col className="text text-vcenter">
										<Link to={`/settings/${user.user.user.username.toLowerCase().replaceAll(' ','_')}`}><Button size="sm">Verify Email</Button></Link>
									</Col>
								</>
							:
								<>
									<Col className="text text-vcenter">
										<Link to="/login"><Button size="sm">Login</Button></Link>
									</Col>
									<Col className="text text-vcenter">
										<Link to="/register"><Button size="sm">Register</Button></Link>
									</Col>
								</>
							}
							
						{/*
							<div className="col-12 mx-1 chatlive-message ps-0 pe-2 pt-2">
								<textarea rows="2" placeholder="Login to send a message" disabled={true}></textarea>
							</div>
							<div className="row">
								<div className="col-6 chatlive-send text-center">
									<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
										<button onClick={this.handleLogin} className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 10px'}}>
											<span className="">Login</span>
										</button>
									</div>

								</div>
								<div className="col-6 chatlive-send text-center">
									<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
										<button onClick={this.handleRegister} className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 10px'}}>
											<span className="">Register</span>
										</button>
									</div>

								</div>
							</div>*/}
						</Row>
					}

				</div>
			</div>
		);
	}
}

export default Chatbox;